module.exports = __webpack_public_path__ + "static/media/title_tu.09b6a457.png";